/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocationProductRequest
 */
export interface UpdateLocationProductRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationProductRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductRequest
     */
    copies?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLocationProductRequest
     */
    printers?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductRequest
     */
    stock?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationProductRequest
     */
    refillPolicy?: UpdateLocationProductRequestRefillPolicyEnum | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductRequest
     */
    refillValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductRequest
     */
    lowStockThreshold?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationProductRequest
     */
    hideOnLowStock?: boolean | null;
}


/**
 * @export
 */
export const UpdateLocationProductRequestRefillPolicyEnum = {
    UntilSoldOut: 'until-sold-out',
    RefillShift: 'refill-shift',
    RefillDaily: 'refill-daily',
    JustToday: 'just-today'
} as const;
export type UpdateLocationProductRequestRefillPolicyEnum = typeof UpdateLocationProductRequestRefillPolicyEnum[keyof typeof UpdateLocationProductRequestRefillPolicyEnum];


/**
 * Check if a given object implements the UpdateLocationProductRequest interface.
 */
export function instanceOfUpdateLocationProductRequest(value: object): value is UpdateLocationProductRequest {
    return true;
}

export function UpdateLocationProductRequestFromJSON(json: any): UpdateLocationProductRequest {
    return UpdateLocationProductRequestFromJSONTyped(json, false);
}

export function UpdateLocationProductRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationProductRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'copies': json['copies'] == null ? undefined : json['copies'],
        'printers': json['printers'] == null ? undefined : json['printers'],
        'stock': json['stock'] == null ? undefined : json['stock'],
        'refillPolicy': json['refillPolicy'] == null ? undefined : json['refillPolicy'],
        'refillValue': json['refillValue'] == null ? undefined : json['refillValue'],
        'lowStockThreshold': json['lowStockThreshold'] == null ? undefined : json['lowStockThreshold'],
        'hideOnLowStock': json['hideOnLowStock'] == null ? undefined : json['hideOnLowStock'],
    };
}

export function UpdateLocationProductRequestToJSON(json: any): UpdateLocationProductRequest {
    return UpdateLocationProductRequestToJSONTyped(json, false);
}

export function UpdateLocationProductRequestToJSONTyped(value?: UpdateLocationProductRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'copies': value['copies'],
        'printers': value['printers'],
        'stock': value['stock'],
        'refillPolicy': value['refillPolicy'],
        'refillValue': value['refillValue'],
        'lowStockThreshold': value['lowStockThreshold'],
        'hideOnLowStock': value['hideOnLowStock'],
    };
}

